module.exports = __webpack_public_path__ + "img/contact.304e6d2d.png";